export default __webpack_public_path__ + "static/media/total-debits.891942bf.svg";